<template>
  <div>
    <div class="DIV2">
      <span class="DIV4" v-show="switchObject.isMustInput">*</span>{{switchObject.label}}
    </div>
    <div class="DIV3">
      <el-switch
        style="margin-top: 7px;"
        v-model="switchObject.isOpneClose"
        active-color="#13ce66"
        inactive-color="#ff4949"
        active-text="启用"
        inactive-text="关闭">
      </el-switch>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      switchObject:{
        //菜单内容
        type: Object
      },
    },
    data () {
      return {
      }
    },
    methods:{

    }
  }
</script>
<style scoped>
  @import '../../assets/common.css';
</style>



// WEBPACK FOOTER //
// src/components/SwitchState/index.vue